import { StyleSheet } from 'aphrodite';
import typography from 'defaults/typography';
import { hexToRgbA } from 'utils/styleUtil';

//All color and font related changes here. The layout will be in .scss file

const getSkin = (theme) => {
    const skin = theme.globalProfiles.palette;
    const myTypography = typography(theme);

    return StyleSheet.create({
        header: {
            ...myTypography.body2,
            fontWeight: '600',
            fontSize: '10px',
            lineHeight: '14px',
            color: skin.white
        },
        value: {
            ...myTypography.body1,
            fontWeight: 'bold',
            lineHeight: '14px',
            color: skin.white
        },
        initialDay: {
            ...myTypography.body1,
            fontWeight: 'bold',
            fontSize: '16px',
            color: '#B6B6B6',
        },
        finalDay: {
            ...myTypography.body1,
            fontWeight: 'bold',
            fontSize: '16px',
            color: skin.secondaryColor,
        },
        budgetChange: {
            ...myTypography.body1,
            fontWeight: 'bold',
            fontSize: '16px',
            color: '#B6B6B6'
        }
    });
}

export default getSkin;
